export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Id',
    },
    cell: {
      type: 'slot',
      name: 'id',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Date',
      sort: 'dateCreated',
    },
    cell: {
      type: 'slot',
      name: 'created',
    },
  },
  {
    width: 7,
    header: {
      type: 'text',
      caption: 'Side',
    },
    cell: {
      type: 'slot',
      name: 'side',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'type',
    },
  },
  {
    width: 10,
    header: {
      type: 'slot',
      name: 'statusHeader',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Amount',
      sort: 'amount',
    },
    cell: {
      type: 'slot',
      name: 'amount',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Balance',
    },
    cell: {
      type: 'slot',
      name: 'balance',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Rate',
    },
    cell: {
      type: 'slot',
      name: 'rate',
    },
  },
  {
    width: 18,
    header: {
      type: 'text',
      caption: 'Transaction method',
    },
    cell: {
      type: 'slot',
      name: 'transactionMethod',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'API',
    },
    cell: {
      type: 'slot',
      name: 'api',
    },
  },
  {
    width: 9,
    header: {
      type: 'text',
      caption: 'Network',
    },
    cell: {
      type: 'slot',
      name: 'network',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Fee',
    },
    cell: {
      type: 'slot',
      name: 'fee',
    },
  },
];
